"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgExternalLink(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 0 14 24" }, props),
        React.createElement("path", { d: "M11 6v2H8v8h8v-3h2v5H6V6h5zm7.997-1v6h-2V8.414l-5.293 5.293-1.414-1.414L15.581 7h-2.584V5h6z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ExternalLink')(SvgExternalLink);
//# sourceMappingURL=ExternalLink.js.map